/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AddPledgeItemsToInventoryInput,
  AddPledgeItemsToInventoryResult,
  HangarAllInventoryItemsParams,
  HangarInventoryItem,
  HangarInventoryItemCreateInput,
  HangarInventoryItemUpdateInput,
  HangarInventoryItemsList,
  HangarInventoryItemsParams,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Create Hangar Inventory Item
 */
export const createHangarInventoryItem = (
    hangarInventorySlug: MaybeRefOrGetter<string>,
    hangarInventoryItemCreateInput: MaybeRefOrGetter<HangarInventoryItemCreateInput>,
 signal?: AbortSignal
) => {
      hangarInventorySlug = toValue(hangarInventorySlug);
hangarInventoryItemCreateInput = toValue(hangarInventoryItemCreateInput);

      return axiosClient<HangarInventoryItem>(
      {url: `/hangar/inventories/${hangarInventorySlug}/items`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: hangarInventoryItemCreateInput, signal
    },
      );
    }




export const getCreateHangarInventoryItemMutationKey = () => ['createHangarInventoryItem'] as const;

export const getCreateHangarInventoryItemMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarInventoryItem>>, TError,CreateHangarInventoryItemMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createHangarInventoryItem>>, TError,CreateHangarInventoryItemMutationVariables, TContext> => {

const mutationKey = getCreateHangarInventoryItemMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHangarInventoryItem>>, CreateHangarInventoryItemMutationVariables> = (props) => {
          const {hangarInventorySlug,data} = props ?? {};

          return  createHangarInventoryItem(hangarInventorySlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHangarInventoryItemMutationResult = NonNullable<Awaited<ReturnType<typeof createHangarInventoryItem>>>
    export type CreateHangarInventoryItemMutationBody = HangarInventoryItemCreateInput
    export type CreateHangarInventoryItemMutationError = ErrorType<ValidationError | StandardError>
    export type CreateHangarInventoryItemMutationVariables = {hangarInventorySlug: string;data: HangarInventoryItemCreateInput}

    /**
 * @summary Create Hangar Inventory Item
 */
export const useCreateHangarInventoryItem = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarInventoryItem>>, TError,CreateHangarInventoryItemMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createHangarInventoryItem>>,
        TError,
        CreateHangarInventoryItemMutationVariables,
        TContext
      > => {
      return useMutation(getCreateHangarInventoryItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Hangar Inventory Items List
 */
export const hangarInventoryItems = (
    hangarInventorySlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<HangarInventoryItemsParams>,
 signal?: AbortSignal
) => {
      hangarInventorySlug = toValue(hangarInventorySlug);
params = toValue(params);

      return axiosClient<HangarInventoryItemsList>(
      {url: `/hangar/inventories/${hangarInventorySlug}/items`, method: 'GET',
        params, signal
    },
      );
    }




export const getHangarInventoryItemsQueryKey = (hangarInventorySlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<HangarInventoryItemsParams>,) => {
    return [
    'hangar','inventories',hangarInventorySlug,'items', ...(params ? [params] : [])
    ] as const;
    }


export const getHangarInventoryItemsQueryOptions = <TData = Awaited<ReturnType<typeof hangarInventoryItems>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(hangarInventorySlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<HangarInventoryItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarInventoryItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarInventoryItemsQueryKey(hangarInventorySlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarInventoryItems>>> = ({ signal }) => hangarInventoryItems(hangarInventorySlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(hangarInventorySlug) !== null && toValue(hangarInventorySlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarInventoryItems>>, TError, TData>
}

export type HangarInventoryItemsQueryResult = NonNullable<Awaited<ReturnType<typeof hangarInventoryItems>>>
export type HangarInventoryItemsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Hangar Inventory Items List
 */

export function useHangarInventoryItems<TData = Awaited<ReturnType<typeof hangarInventoryItems>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 hangarInventorySlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<HangarInventoryItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarInventoryItems>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarInventoryItemsQueryOptions(hangarInventorySlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Add Hangar Pledge Items to an Inventory
 */
export const addPledgeItemsToHangarInventory = (
    hangarInventorySlug: MaybeRefOrGetter<string>,
    addPledgeItemsToInventoryInput: MaybeRefOrGetter<AddPledgeItemsToInventoryInput>,
 signal?: AbortSignal
) => {
      hangarInventorySlug = toValue(hangarInventorySlug);
addPledgeItemsToInventoryInput = toValue(addPledgeItemsToInventoryInput);

      return axiosClient<AddPledgeItemsToInventoryResult>(
      {url: `/hangar/inventories/${hangarInventorySlug}/items/from-pledge-items`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addPledgeItemsToInventoryInput, signal
    },
      );
    }




export const getAddPledgeItemsToHangarInventoryMutationKey = () => ['addPledgeItemsToHangarInventory'] as const;

export const getAddPledgeItemsToHangarInventoryMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPledgeItemsToHangarInventory>>, TError,AddPledgeItemsToHangarInventoryMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addPledgeItemsToHangarInventory>>, TError,AddPledgeItemsToHangarInventoryMutationVariables, TContext> => {

const mutationKey = getAddPledgeItemsToHangarInventoryMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addPledgeItemsToHangarInventory>>, AddPledgeItemsToHangarInventoryMutationVariables> = (props) => {
          const {hangarInventorySlug,data} = props ?? {};

          return  addPledgeItemsToHangarInventory(hangarInventorySlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddPledgeItemsToHangarInventoryMutationResult = NonNullable<Awaited<ReturnType<typeof addPledgeItemsToHangarInventory>>>
    export type AddPledgeItemsToHangarInventoryMutationBody = AddPledgeItemsToInventoryInput
    export type AddPledgeItemsToHangarInventoryMutationError = ErrorType<ValidationError | StandardError>
    export type AddPledgeItemsToHangarInventoryMutationVariables = {hangarInventorySlug: string;data: AddPledgeItemsToInventoryInput}

    /**
 * @summary Add Hangar Pledge Items to an Inventory
 */
export const useAddPledgeItemsToHangarInventory = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPledgeItemsToHangarInventory>>, TError,AddPledgeItemsToHangarInventoryMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addPledgeItemsToHangarInventory>>,
        TError,
        AddPledgeItemsToHangarInventoryMutationVariables,
        TContext
      > => {
      return useMutation(getAddPledgeItemsToHangarInventoryMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Hangar Inventory Item
 */
export const destroyHangarInventoryItem = (
    hangarInventorySlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      hangarInventorySlug = toValue(hangarInventorySlug);
id = toValue(id);

      return axiosClient<void>(
      {url: `/hangar/inventories/${hangarInventorySlug}/items/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyHangarInventoryItemMutationKey = () => ['destroyHangarInventoryItem'] as const;

export const getDestroyHangarInventoryItemMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarInventoryItem>>, TError,DestroyHangarInventoryItemMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyHangarInventoryItem>>, TError,DestroyHangarInventoryItemMutationVariables, TContext> => {

const mutationKey = getDestroyHangarInventoryItemMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyHangarInventoryItem>>, DestroyHangarInventoryItemMutationVariables> = (props) => {
          const {hangarInventorySlug,id} = props ?? {};

          return  destroyHangarInventoryItem(hangarInventorySlug,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyHangarInventoryItemMutationResult = NonNullable<Awaited<ReturnType<typeof destroyHangarInventoryItem>>>

    export type DestroyHangarInventoryItemMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyHangarInventoryItemMutationVariables = {hangarInventorySlug: string;id: string}

    /**
 * @summary Delete Hangar Inventory Item
 */
export const useDestroyHangarInventoryItem = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarInventoryItem>>, TError,DestroyHangarInventoryItemMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyHangarInventoryItem>>,
        TError,
        DestroyHangarInventoryItemMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyHangarInventoryItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Update Hangar Inventory Item
 */
export const updateHangarInventoryItem = (
    hangarInventorySlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    hangarInventoryItemUpdateInput: MaybeRefOrGetter<HangarInventoryItemUpdateInput>,
 signal?: AbortSignal
) => {
      hangarInventorySlug = toValue(hangarInventorySlug);
id = toValue(id);
hangarInventoryItemUpdateInput = toValue(hangarInventoryItemUpdateInput);

      return axiosClient<HangarInventoryItem>(
      {url: `/hangar/inventories/${hangarInventorySlug}/items/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: hangarInventoryItemUpdateInput, signal
    },
      );
    }




export const getUpdateHangarInventoryItemMutationKey = () => ['updateHangarInventoryItem'] as const;

export const getUpdateHangarInventoryItemMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarInventoryItem>>, TError,UpdateHangarInventoryItemMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateHangarInventoryItem>>, TError,UpdateHangarInventoryItemMutationVariables, TContext> => {

const mutationKey = getUpdateHangarInventoryItemMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHangarInventoryItem>>, UpdateHangarInventoryItemMutationVariables> = (props) => {
          const {hangarInventorySlug,id,data} = props ?? {};

          return  updateHangarInventoryItem(hangarInventorySlug,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHangarInventoryItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateHangarInventoryItem>>>
    export type UpdateHangarInventoryItemMutationBody = HangarInventoryItemUpdateInput
    export type UpdateHangarInventoryItemMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateHangarInventoryItemMutationVariables = {hangarInventorySlug: string;id: string;data: HangarInventoryItemUpdateInput}

    /**
 * @summary Update Hangar Inventory Item
 */
export const useUpdateHangarInventoryItem = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarInventoryItem>>, TError,UpdateHangarInventoryItemMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateHangarInventoryItem>>,
        TError,
        UpdateHangarInventoryItemMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateHangarInventoryItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Hangar All Inventory Items
 */
export const hangarAllInventoryItems = (
    params?: MaybeRefOrGetter<HangarAllInventoryItemsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<HangarInventoryItemsList>(
      {url: `/hangar/inventory-items`, method: 'GET',
        params, signal
    },
      );
    }




export const getHangarAllInventoryItemsQueryKey = (params?: MaybeRefOrGetter<HangarAllInventoryItemsParams>,) => {
    return [
    'hangar','inventory-items', ...(params ? [params] : [])
    ] as const;
    }


export const getHangarAllInventoryItemsQueryOptions = <TData = Awaited<ReturnType<typeof hangarAllInventoryItems>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<HangarAllInventoryItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarAllInventoryItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarAllInventoryItemsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarAllInventoryItems>>> = ({ signal }) => hangarAllInventoryItems(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarAllInventoryItems>>, TError, TData>
}

export type HangarAllInventoryItemsQueryResult = NonNullable<Awaited<ReturnType<typeof hangarAllInventoryItems>>>
export type HangarAllInventoryItemsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Hangar All Inventory Items
 */

export function useHangarAllInventoryItems<TData = Awaited<ReturnType<typeof hangarAllInventoryItems>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<HangarAllInventoryItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarAllInventoryItems>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarAllInventoryItemsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






